/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../resources/enums';
import '../../resources/error';
import '../resources/datatypes';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "connect": {
        "nested": {
          "v2": {
            "nested": {
              "merchant_catalog": {
                "nested": {
                  "service": {
                    "nested": {
                      "SyncCatalogObjectsRequest": {
                        "fields": {
                          "cursor": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "objectTypes": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogObjectType",
                            "id": 2,
                            "rule": "repeated"
                          },
                          "modifiedAfter": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          },
                          "includeRelatedObjects": {
                            "type": "bool",
                            "id": 4,
                            "rule": "optional",
                            "options": {
                              "default": false
                            }
                          },
                          "limit": {
                            "type": "int32",
                            "id": 5,
                            "rule": "optional"
                          }
                        }
                      },
                      "SyncCatalogObjectsResponse": {
                        "fields": {
                          "errors": {
                            "type": "squareup.connect.v2.resources.Error",
                            "id": 1,
                            "rule": "repeated"
                          },
                          "cursor": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "objects": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogObject",
                            "id": 3,
                            "rule": "repeated"
                          },
                          "relatedObjects": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogObject",
                            "id": 4,
                            "rule": "repeated"
                          },
                          "latestTime": {
                            "type": "string",
                            "id": 5,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.service?.nested?.SyncCatalogObjectsRequest && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.service?.nested?.SyncCatalogObjectsResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE SyncCatalogObjectsRequest @ squareup/connect/v2/catalog/interfaces/sync-catalog-obj.proto at 19:1
 */
export const SyncCatalogObjectsRequest = $root.lookupType('squareup.connect.v2.merchant_catalog.service.SyncCatalogObjectsRequest');
fixType(SyncCatalogObjectsRequest);
Builder.createAndAttachToType(SyncCatalogObjectsRequest);
/**
 * SOURCE SyncCatalogObjectsResponse @ squareup/connect/v2/catalog/interfaces/sync-catalog-obj.proto at 80:1
 */
export const SyncCatalogObjectsResponse = $root.lookupType('squareup.connect.v2.merchant_catalog.service.SyncCatalogObjectsResponse');
fixType(SyncCatalogObjectsResponse);
Builder.createAndAttachToType(SyncCatalogObjectsResponse);